export class Timer {
    /**
     * Number of miliseconds to delay firing the provided function
     * @param {Number} delay
     */
    constructor(delay = null) {
        this.timer = null;
        this.delay = null;
        if (delay === null) {
            throw new Error('delay cannot be null');
        }
        this.delay = delay;
    }
    /**
     * Function to fire once alloted delay has been reached.
     * @param {() => void} func
     */
    Delay(func) {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(func, this.delay);
    }
}
